import { render, staticRenderFns } from "./CustomValue.vue?vue&type=template&id=3c34fecd&"
import script from "./CustomValue.vue?vue&type=script&lang=js&"
export * from "./CustomValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports